import { render, staticRenderFns } from "./DetailCustomerActivities.vue?vue&type=template&id=61ec26a1&"
import script from "./DetailCustomerActivities.vue?vue&type=script&lang=js&"
export * from "./DetailCustomerActivities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports